import React from "react";
import { Row, Container, Col } from "react-bootstrap";
import {
  BuildIcon,
  DesignIcon,
  LaunchIcon,
  MaintenanceIcon,
  PlaneIcon,
  TestIcon,
} from "../../../app-constants";

import { Link } from "gatsby";

const WorkFlow = [
  {
    logo: PlaneIcon,
    title: "Trusted ML Talent",
    description:
      "Our top ML engineers deliver high-impact solutions using advanced algorithms and deep learning techniques across diverse industries.",
    count: "01",
  },
  {
    logo: DesignIcon,
    title: "Custom ML Solutions",
    description:
      "We develop customized models for predictive maintenance, fraud detection, and personalized recommendations, optimizing for your unique business challenges.",
    count: "02",
  },
  {
    logo: BuildIcon,
    title: "Agile Development Process",
    description:
      "Using agile methodologies, we rapidly develop, deploy, and refine ML models, ensuring swift time-to-market and continuous improvement.",
    count: "03",
  },
  {
    logo: LaunchIcon,
    title: "Domain-Specific Expertise",
    description:
      "Our team has deep knowledge in healthcare, finance, retail, and manufacturing, creating models that provide actionable insights and high ROI.",
    count: "04",
  },
  {
    logo: TestIcon,
    title: "Continuous Support",
    description:
      "Post-deployment, we offer ongoing monitoring and optimization, ensuring your ML models adapt to new data and business needs.",
    count: "05",
  },
  {
    logo: MaintenanceIcon,
    title: "Secure Data Handling",
    description:
      "We implement strict security protocols, ensuring compliance with industry standards to protect your sensitive information throughout the ML lifecycle.",
    count: "06",
  },
];
const Workflow = () => {
  return (
    <div className="workflow machine_why_choose p-100">
      <Container>
        <Row>
          <Col
            xs={12}
            md={9}
            lg={8}
            xl={8}
            xxl={8}
            className="m-auto text-center"
          >
            <h2>
              Why Choose TekRevol as Your Machine Learning Development Company?
            </h2>
            <p>
              We specialize in{" "}
              <Link to="https://www.tekrevol.com/ai-development-company">
                AI development
              </Link>{" "}
              by leveraging advanced neural networks, scalable data pipelines,
              and custom algorithms. Using TensorFlow and PyTorch, we ensure
              high-performance, secure deployments. Our focus on explainable AI
              and continuous model improvement delivers precise, robust machine
              learning development services tailored to your business.
            </p>
            <Link
              to="/contact"
              className="border_btn"
              aria-label="TekRevol Contact"
            >
              Talk to Our ML Experts
            </Link>
          </Col>
        </Row>
        <Row className="workflow_secion">
          {WorkFlow.map((item, index) => (
            <Col xs={12} md={6} lg={4} xl={4} xxl={4} className="my-auto">
              <div className="workflow_items">
                <div className="item_name">
                  <span>{item.count}</span>
                  {item.title}
                  <div className="item_icon"> {item.logo}</div>
                </div>
                <p>{item.description}</p>
              </div>
            </Col>
          ))}
        </Row>
      </Container>
    </div>
  );
};

export default Workflow;
